import React from "react";
export default function LongswitchAcademyLogoAnimation() {
    return (
        <>
            <div>
                <div className="spinner-body-container spinner-loading" style={{ display: "none" }}>
                    <svg width="300" height="300" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg"
                        className="logo-container">
                        {/* <!-- hat --> */}
                        <path
                            d="M283.802 344.204C283.802 344.204 305.07 304.336 334.169 287.357C367.665 267.813 411.045 274.034 411.045 274.034L391.605 245.611L338.587 268.705L314.729 282.028C314.729 282.028 332.57 257.233 350.958 241.17C362.161 231.383 387.187 229.623 387.187 229.623L415.463 171L260.828 210.97L176 335.321L266.13 321.11L283.802 344.204Z"
                            fill="#000039" className="e hat" />

                        {/* <!-- ball --> */}
                        <g className="e ball">
                            <path fillRule="evenodd" clipRule="evenodd"
                                d="M519.462 400.023C519.462 334.043 465.811 281.244 400.173 281.001C334.29 280.757 280 333.797 280 400.023C280 466.249 334.29 519.289 400.173 519.045C412.143 519.001 423.714 517.208 434.634 513.907C439.796 512.347 444.812 510.449 449.656 508.24C490.759 489.491 519.462 448.283 519.462 400.023ZM400.173 306.759C451.659 306.759 492.64 348.283 493.837 400.023C494.54 430.378 480.992 458.026 459.376 476.102C443.269 489.572 422.681 497.728 400.173 497.728C347.458 497.728 305.283 452.997 306.509 400.023C306.933 381.697 312.347 364.654 321.452 350.282C338.053 324.078 366.922 306.759 400.173 306.759Z"
                                fill="#000039" />
                            <path
                                d="M493.837 400.023C492.64 348.283 451.659 306.759 400.173 306.759C366.922 306.759 338.053 324.078 321.452 350.282C321.452 350.282 331.441 415.68 359.526 442.658C361.484 444.538 363.617 446.316 365.895 447.997C376.466 455.8 390.137 461.506 403.744 465.652C411.074 467.885 418.385 469.666 425.183 471.078C425.858 471.218 426.528 471.354 427.192 471.487C430.067 472.063 432.839 472.572 435.468 473.021C449.442 475.408 459.376 476.102 459.376 476.102C480.992 458.026 494.54 430.378 493.837 400.023Z"
                                fill="#FF4500" />
                            <path
                                d="M306.509 400.023C305.283 452.997 347.458 497.728 400.173 497.728C422.681 497.728 443.269 489.572 459.376 476.102C459.376 476.102 449.442 475.408 435.468 473.021C432.839 472.572 430.067 472.063 427.192 471.487C426.528 471.354 425.858 471.218 425.183 471.078C418.385 469.666 411.074 467.885 403.744 465.652C390.137 461.506 376.466 455.8 365.895 447.997C363.617 446.316 361.484 444.538 359.526 442.658C331.441 415.68 321.452 350.282 321.452 350.282C312.347 364.654 306.933 381.697 306.509 400.023Z"
                                fill="#FA7E18" />
                        </g>

                        {/* <!-- smile --> */}

                        <path
                            d="M401.024 466.778C378.064 466.121 359.422 454.509 350.086 447.387C347.577 445.474 343.588 447.262 343.588 450.418V452.995C343.588 455.546 344.672 457.965 346.706 459.505C354.487 465.403 375.954 479.667 401.024 479.214C425.685 478.768 443.732 467.548 450.37 462.728C452.208 461.393 453.278 459.301 453.492 457.039L453.838 453.381C454.168 449.9 449.321 447.649 446.622 449.872C437.526 457.367 421.47 467.364 401.024 466.778Z"
                            fill="#000039" className="e smile" />

                        {/* <!-- semi-circle --> */}
                        <path
                            d="M461.411 508.267C461.411 508.267 528.367 478.886 525.916 391.168C523.98 321.884 457.877 289.022 457.877 289.022C457.877 289.022 531.146 313.175 532.985 391.168C535.338 490.939 461.411 508.267 461.411 508.267Z"
                            fill="#FA7E18" className="e semi-circle" />

                        {/* <!-- tail --> */}
                        <path
                            d="M440.031 511C440.031 511 449.804 517.599 450.031 524C450.052 524.59 449.992 525.185 449.865 525.779C447.693 535.94 434.448 538 424.057 538H374.381C364.435 538 349.984 540.609 351.031 550.5V550.5V550.5C351.932 559.011 363.602 560.5 372.161 560.5H426.555C435.381 560.5 446.116 561.656 449.532 569.795C449.973 570.844 450.179 571.924 450.031 573C449.876 574.13 449.339 575.207 448.588 576.203C444.336 581.843 436.379 582.5 429.316 582.5H392.193C383.017 582.5 369.929 584.843 370.531 594V594V594C371.078 602.323 382.515 604 390.856 604H431.031"
                            stroke="#000039" className="e tail" />
                    </svg>
                </div>
                <div className="spinner-body-container spinner-loading">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 320"
                        width="300" height="300"
                        aria-label="Loading"
                        role="img"
                        className="logo-container"
                    >
                        <defs>
                            <linearGradient
                                id="academyGradient"
                                x1="0"
                                y1="0"
                                x2="1"
                                y2="1"
                            >
                                <stop offset="0%" stop-color="#535FE2" />
                                <stop offset="100%" stop-color="#6874EA" />
                            </linearGradient>
                        </defs>



                        <circle
                            cx="160"
                            cy="160"
                            r="112"
                            fill="none"
                            stroke="#535FE2"
                            stroke-width="1.5"
                            stroke-dasharray="3 13"
                            opacity="0.18"
                        >
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                from="0 160 160"
                                to="360 160 160"
                                dur="12s"
                                repeatCount="indefinite"
                            />
                        </circle>



                        <circle
                            cx="160"
                            cy="160"
                            r="88"
                            fill="none"
                            stroke="#535FE2"
                            stroke-width="1.5"
                            stroke-dasharray="18 16"
                            opacity="0.14"
                        >
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                from="360 160 160"
                                to="0 160 160"
                                dur="9s"
                                repeatCount="indefinite"
                            />
                        </circle>




                        <g
                            fill="none"
                            stroke="#535FE2"
                            stroke-linecap="round"
                        >

                            <path
                                d="M160 48V78"
                                stroke-width="2"
                                opacity="0.18"
                            />

                            <path
                                d="M272 160H242"
                                stroke-width="2"
                                opacity="0.18"
                            />

                            <path
                                d="M160 272V242"
                                stroke-width="2"
                                opacity="0.18"
                            />

                            <path
                                d="M48 160H78"
                                stroke-width="2"
                                opacity="0.18"
                            />

                        </g>



                        <g fill="#535FE2">



                            <circle
                                cx="160"
                                cy="48"
                                r="4"
                            >
                                <animate
                                    attributeName="r"
                                    values="3;5;3"
                                    dur="2s"
                                    repeatCount="indefinite"
                                />

                                <animate
                                    attributeName="opacity"
                                    values="0.3;1;0.3"
                                    dur="2s"
                                    repeatCount="indefinite"
                                />
                            </circle>




                            <circle
                                cx="272"
                                cy="160"
                                r="4"
                            >
                                <animate
                                    attributeName="r"
                                    values="3;5;3"
                                    dur="2s"
                                    begin="0.5s"
                                    repeatCount="indefinite"
                                />

                                <animate
                                    attributeName="opacity"
                                    values="0.3;1;0.3"
                                    dur="2s"
                                    begin="0.5s"
                                    repeatCount="indefinite"
                                />
                            </circle>




                            <circle
                                cx="160"
                                cy="272"
                                r="4"
                            >
                                <animate
                                    attributeName="r"
                                    values="3;5;3"
                                    dur="2s"
                                    begin="1s"
                                    repeatCount="indefinite"
                                />

                                <animate
                                    attributeName="opacity"
                                    values="0.3;1;0.3"
                                    dur="2s"
                                    begin="1s"
                                    repeatCount="indefinite"
                                />
                            </circle>




                            <circle
                                cx="48"
                                cy="160"
                                r="4"
                            >
                                <animate
                                    attributeName="r"
                                    values="3;5;3"
                                    dur="2s"
                                    begin="1.5s"
                                    repeatCount="indefinite"
                                />

                                <animate
                                    attributeName="opacity"
                                    values="0.3;1;0.3"
                                    dur="2s"
                                    begin="1.5s"
                                    repeatCount="indefinite"
                                />
                            </circle>

                        </g>



                        <circle
                            r="4"
                            fill="#535FE2"
                        >
                            <animateMotion
                                dur="3.2s"
                                repeatCount="indefinite"
                                path="
        M160 48
        L160 78
        L242 160
        L160 242
        L78 160
        L160 78
      "
                            />

                            <animate
                                attributeName="r"
                                values="3;5;3"
                                dur="0.8s"
                                repeatCount="indefinite"
                            />
                        </circle>




                        <circle
                            cx="160"
                            cy="160"
                            r="63"
                            fill="none"
                            stroke="#535FE2"
                            stroke-width="1.5"
                            opacity="0.10"
                        >
                            <animate
                                attributeName="r"
                                values="60;64;60"
                                dur="3s"
                                repeatCount="indefinite"
                            />
                        </circle>



                        <g transform="translate(160 160)">



                            <g>



                                <polygon
                                    points="
          -54,-15
          0,-34
          54,-15
          0,4
        "
                                    fill="url(#academyGradient)"
                                />




                                <path
                                    d="
          M-38 -9
          L-37 17
          Q0 42 37 17
          L38 -9
          L0 5
          Z
        "
                                    fill="#535FE2"
                                />




                                <path
                                    d="M0 4V38"
                                    fill="none"
                                    stroke="#FFFFFF"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    opacity="0.65"
                                />




                                <path
                                    d="M54 -15V18"
                                    fill="none"
                                    stroke="#535FE2"
                                    stroke-width="3"
                                    stroke-linecap="round"
                                />

                                <circle
                                    cx="54"
                                    cy="22"
                                    r="4.5"
                                    fill="#535FE2"
                                />


                                <animateTransform
                                    attributeName="transform"
                                    type="translate"
                                    values="
          0 0;
          0 -4;
          0 0;
          0 4;
          0 0
        "
                                    dur="3.2s"
                                    repeatCount="indefinite"
                                />

                            </g>

                        </g>



                        <circle
                            cx="160"
                            cy="160"
                            r="66"
                            fill="none"
                            stroke="#535FE2"
                            stroke-width="1"
                            opacity="0"
                        >
                            <animate
                                attributeName="r"
                                values="62;80;62"
                                dur="3.2s"
                                repeatCount="indefinite"
                            />

                            <animate
                                attributeName="opacity"
                                values="0;0.12;0"
                                dur="3.2s"
                                repeatCount="indefinite"
                            />
                        </circle>

                    </svg>
                </div>
            </div>
        </>
    )
}